import { CashSessionStatus } from '@/@types/cash-management';

export const cashSessionSummaryStatusLabel: Record<CashSessionStatus, string> =
  {
    OPEN: 'Aberto',
    RECONCILIATION: 'Em conferência',
    CLOSED: 'Fechado',
  };

export const formatSummaryCurrency = (value: number) => {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const formatSummaryDateTime = (value: string | null) => {
  if (!value) return '-';

  return new Date(value).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
